import { render, staticRenderFns } from "./tab_Premium.vue?vue&type=template&id=d07258f8&"
import script from "./tab_Premium.vue?vue&type=script&lang=js&"
export * from "./tab_Premium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports